import { useServiceAreasStore } from '../store/serviceAreasStore';
import { useStructuresStore } from '../store/structuresStore';
import { DEFAULT_REGION } from '../components/map/types';

/** The id of the area under the center of the map view, or 'unassigned'.
 *  Used to decide which uploaded People lists to show and where a new one
 *  is saved. Never shown to the user (areas are backend-only). */
export function useMapAreaId(): string {
  // Re-evaluate when the areas load, not only when the map pans.
  useServiceAreasStore((s) => s.areas);
  return useStructuresStore((s) => {
    const c = s._lastViewportCenter ?? {
      lat: DEFAULT_REGION.latitude,
      lng: DEFAULT_REGION.longitude,
    };
    return useServiceAreasStore.getState().findContaining(c.lat, c.lng)?.id ?? 'unassigned';
  });
}
